<script setup lang="ts">
import { RouterLink } from 'hybridly/vue'

const { user } = useUser()

function switchToTeam(team: App.Data.Team.TeamData) {
	router.put(
		route('current-team.update'),
		{
			data: {
				team_id: team.uuid,
			},
			preserveState: false,
		},
	)
}
</script>

<template>
	<ui-sidebar-menu>
		<ui-sidebar-menu-item>
			<ui-dropdown-menu>
				<ui-dropdown-menu-trigger as-child>
					<ui-sidebar-menu-button
						size="lg"
						class="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
					>
						<ui-avatar class="size-8 rounded-lg">
							<ui-avatar-initials :name="user.current_team?.name ?? ''" class="shrink-0 rounded-sm" :style="{ '--avatar-background': user.current_team?.brand_color_foreground, '--avatar-foreground': user.current_team?.brand_color }" />
						</ui-avatar>

						<div class="grid flex-1 text-left text-sm leading-tight">
							<span class="truncate font-semibold">{{ user.current_team?.name }}</span>
							<span class="truncate text-xs">{{ user.current_team?.plan.label }}</span>
						</div>
						<i-ph-caret-down-bold class="ml-auto" />
					</ui-sidebar-menu-button>
				</ui-dropdown-menu-trigger>
				<ui-dropdown-menu-content
					class="w-[var(--radix-dropdown-menu-trigger-width)] min-w-56 rounded-lg"
					align="start"
					side="bottom"
					:side-offset="4"
				>
					<ui-dropdown-menu-label class="text-muted-foreground text-xs">
						{{ t('app.teams') }}
					</ui-dropdown-menu-label>
					<ui-dropdown-menu-item
						v-for="team in user.teams"
						:key="team.uuid"
						class="cursor-pointer gap-2 p-2"
						@click="switchToTeam(team)"
					>
						<ui-avatar class="size-6 rounded-sm border">
							<ui-avatar-initials :name="team.name" class="shrink-0 rounded-sm" :style="{ '--avatar-background': team.brand_color_foreground, '--avatar-foreground': team.brand_color }" />
						</ui-avatar>

						{{ team.name }}
					</ui-dropdown-menu-item>
					<ui-dropdown-menu-separator />
					<ui-dropdown-menu-item class="gap-2 p-2" :as="RouterLink" :href="route('teams.create')">
						<div class="bg-background flex size-6 items-center justify-center rounded-md border">
							<i-ph-plus-bold class="size-4" />
						</div>
						<div>
							{{ t('app.create_new_team') }}
						</div>
					</ui-dropdown-menu-item>
				</ui-dropdown-menu-content>
			</ui-dropdown-menu>
		</ui-sidebar-menu-item>
	</ui-sidebar-menu>
</template>
